import React, { useState, useEffect } from 'react';
import ListItemButton from '@mui/material/ListItemButton';
import TR from './../../Trans';
import { useInView } from "react-intersection-observer";
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import MenuItem from '@mui/material/MenuItem';
import SvgIcon from '@mui/material/SvgIcon';
import Tooltip from '@mui/material/Tooltip';
import { ReactComponent as VocIcon } from './../../assets/voc.svg';
import ListItemText from '@mui/material/ListItemText';
import IntervalService from './../../services/intervals';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import IconButton from '@mui/material/IconButton';
import StarIcon from '@mui/icons-material/Star';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import RemoveFavorite from '../dialogs/RemoveFavorite';
import settingsStore from '../../stores/settings';
import sessionStore from './../../stores/session';
import performanceStore from '../../stores/performance';
import favoritesStore from '../../stores/favorites';

function PerformancePeekListItem(props) {

  const thisPerformance = performanceStore((state) => state.playLists?.find(x => x.id == props.playListId)?.items?.find(x => x.position == props.index));
  const sessionToken = sessionStore((state) => state.sessionToken);
  const performanceToBeChanged = performanceStore((state) => state.performanceToBeChanged);
  const deleteFavorite = favoritesStore((state) => state.deleteFavorite);
  const setFavorite = favoritesStore((state) => state.setFavorite);
  const moveUpInPlayList = performanceStore((state) => state.moveUpInPlayList);
  const moveDownInPlayList = performanceStore((state) => state.moveDownInPlayList);
  const moveToTopInPlayList = performanceStore((state) => state.moveToTopInPlayList);
  const moveToSecondInPlayList = performanceStore((state) => state.moveToSecondInPlayList);
  const moveToBottomInPlayList = performanceStore((state) => state.moveToBottomInPlayList);
  const deletePerformanceInPlayList = performanceStore((state) => state.deletePerformanceInPlayList);
  const settingsUsageMode = settingsStore((state) => state.settings?.usage_mode);

  const [showPlay, setShowPlay] = useState(false);

  useEffect(() => {
    console.log("thisPerformance", thisPerformance, props.playListId, props.performanceId);
  }, [thisPerformance]);

  const isFavorite = favoritesStore(
    (state) => state.tracks?.find(x => x.track_id == thisPerformance?.track.track_id && x.is_favorite == 1)
  );

  const [anchorEl, setAnchorEl] = useState(null);
  const [isMenuOpen, setMenuOpen] = useState(false);

  const handleMenuClose = () => {
    setMenuOpen(false);
    props.onMenuClose();
  };

  const openMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setMenuOpen(true);
  };

  const handleMoveToTop = () => {
    moveToTopInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveToSecond = () => {
    moveToSecondInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveToBottom = () => {
    moveToBottomInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveUp = () => {
    moveUpInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const handleMoveDown = () => {
    moveDownInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
  };

  const renderMoveToFirst = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();

        handleMoveToTop();
        handleMenuClose();
      }}>{TR.cm_move_to_top}</MenuItem>;
    }
  };

  const renderMoveToSecond = () => {
    if (props.count > 1 && thisPerformance?.position != 1) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();

        handleMoveToSecond();
        handleMenuClose();
      }}>{TR.cm_move_to_second}</MenuItem>;
    }
  };

  const renderMoveUp = () => {
    if (thisPerformance?.position > 0) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();

        handleMoveUp();
        handleMenuClose();
      }}>{TR.cm_move_up}</MenuItem>;
    }
  };

  const renderMoveDown = () => {
    if (thisPerformance?.position < props.count - 1) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();

        handleMoveDown();
        handleMenuClose();
      }}>{TR.cm_move_down}</MenuItem>;
    }
  };

  const renderMoveToLast = () => {
    if (thisPerformance?.position < props.count - 1) {
      return <MenuItem onClick={(e) => {

        e.stopPropagation();
        handleMoveToBottom();
        handleMenuClose();
      }}>{TR.cm_move_to_bottom}</MenuItem>;
    }
  };

  const renderDelete = () => {
    return <MenuItem onClick={(e) => {
      e.stopPropagation();
      deletePerformanceInPlayList(sessionToken, props.playListId, thisPerformance?.unique_id);
      handleMenuClose();
    }}>{TR.cm_delete}</MenuItem>;
  };

  const renderStarIcon = () => {
    if (isFavorite) {
      return <StarIcon className="muvika-yellow-star" />;
    } else {
      return <StarIcon className="muvika-empty-star" />;
    }
  };

  const showPlayIcon = () => {
    if (showPlay) {
      return <PlayArrowIcon className="muvika-track-play-icon" />;
    }
  };

  const renderPlayButton = () => {
    return <IconButton color="white" component="label" size="large" onClick={(e) => {
      e.stopPropagation();
      props.onPlayNow(thisPerformance);
    }}>
      <PlayArrowIcon />
    </IconButton>;
  };

  const handleSetFavorite = (event) => {
    event.stopPropagation();
    if (isFavorite) {
      deleteFavorite(sessionToken, thisPerformance?.track);
    } else {
      setFavorite(sessionToken, thisPerformance?.track);
    }
  };

  const toMinutes = (secs) => {
    var sec_num = parseInt(secs, 10);
    var minutes = Math.floor(sec_num / 60);
    return minutes;
  };

  const lengthToMinutes = (length) => {
    if (length) {
      const splitted = length.split(":");
      if (splitted.length == 3) {
        return splitted[1] + ":" + splitted[2];
      }
    }
  };

  const renderFavoritesStar = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
          {renderStarIcon()}
        </IconButton>;
      }
    } else {
      return <IconButton className="muvika-list-star" color="white" component="label" size="large" onClick={handleSetFavorite}>
        {renderStarIcon()}
      </IconButton>;
    }
  };

  const vocalImg = () => {
    if (thisPerformance?.track) {
      if (thisPerformance?.track.flags) {
        if (thisPerformance?.track.flags.includes("voc_avail")) {
          return <Tooltip title={TR.cm_vocal_version_available}><SvgIcon className="muvika-icon track-list-item-icon" component={VocIcon} /></Tooltip>;
        }
      }
    }
  };

  const primaryText = () => {
    return <span>{thisPerformance?.position + 1}. {thisPerformance?.profile.name} - {thisPerformance?.track.title} {vocalImg()}</span>;
  };

  const secondaryText = thisPerformance?.track.artist;

  const handleItemClick = (e) => {
    if (performanceToBeChanged) {
      props.onChangeTrackPerformance(e, thisPerformance);
    } else {
      props.onEditPerformance(e, thisPerformance);
    }
  };

  const renderMenuButton = () => {
    if (settingsUsageMode) {
      if (settingsUsageMode === "restaurant") {
        return <IconButton
          id={"menu-button-" + thisPerformance?.unique_id}
          color="white"
          component="label"
          size="small"
          aria-controls={isMenuOpen ? "menu-" + thisPerformance?.unique_id : undefined}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? 'true' : undefined}
          onClick={(e) => {

            e.stopPropagation();
            openMenu(e);
          }} >
          <MenuIcon />
        </IconButton>;
      }
    } else {
      return <IconButton
        id={"menu-button-" + thisPerformance?.unique_id}
        color="white"
        component="label"
        size="small"
        aria-controls={isMenuOpen ? "menu-" + thisPerformance?.unique_id : undefined}
        aria-haspopup="true"
        aria-expanded={isMenuOpen ? 'true' : undefined}
        onClick={(e) => {

          e.stopPropagation();
          openMenu(e);
        }} >
        <MenuIcon />
      </IconButton>;
    }
  };

  const primaryRightTop = (thisPerformance?.pitch != 0 ? (thisPerformance?.pitch > 0 ? "+" : "") + thisPerformance?.pitch + " " : "");

  const renderButton = () => {
    if (thisPerformance) {
      return <ListItemButton sx={{
        marginLeft: "1.2rem",
        bgcolor: isMenuOpen ? 'rgba(255, 255, 255, 0.08)' : 'unset'
      }} onClick={(e) => {
        handleItemClick(e);
      }} onMouseOver={() => setShowPlay(true)} onMouseOut={() => setShowPlay(false)}>
        <ListItemAvatar className="muvika-track-avatar-item">
          <Avatar className="muvika-track-avatar">
            {showPlayIcon()}
            <img className="muvika-track-avatar-image" src={thisPerformance?.track.url_thumb_image} alt="" />
          </Avatar>
        </ListItemAvatar>
        <ListItemText primary={primaryText()} secondary={secondaryText} />
        <ListItemText
          className="muvika-list-right-playlists"
          primary={
            <div>
              {lengthToMinutes(thisPerformance?.track.length)}
              <span className="muvika-performance-list-item-minutes-container">
                <span> - </span>
                <span className="muvika-performance-list-item-minutes">
                  {toMinutes(thisPerformance?.incoming) + " min"}
                </span>
              </span>
            </div>
          }
          secondary={primaryRightTop + " " + thisPerformance?.track.kcode}
        />
        {renderPlayButton()}
        {renderFavoritesStar()}
        {renderMenuButton()}
        <Menu disableAutoFocus disableEnforceFocus disableRestoreFocus  
          id={"menu-" + thisPerformance?.unique_id}
          open={isMenuOpen}
          anchorEl={anchorEl}
          onClose={(e) => {

            e.stopPropagation();
            handleMenuClose();
          }}
          MenuListProps={{
            'aria-labelledby': 'menu-button-' + thisPerformance?.unique_id,
          }}
        >
          <MenuItem onClick={(e) => {

            e.stopPropagation();
            handleMenuClose();
            props.onEditPerformance(e, thisPerformance);
          }}>{TR.cm_edit}</MenuItem>
          {renderMoveToFirst()}
          {renderMoveToSecond()}
          {renderMoveUp()}
          {renderMoveDown()}
          {renderMoveToLast()}
          {renderDelete()}
        </Menu>
      </ListItemButton>;
    }
  };

  return (
    <Draggable key={props.key} draggableId={props.draggableId} index={props.index}>
      {(provided, snapshot) => (
        <div
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {renderButton()}
        </div>
      )}
    </Draggable>
  );
}

export default PerformancePeekListItem;